import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar.component';
import { GenericSharedModule } from '../../generics/generic-shared.module';

@NgModule({
  imports: [RouterModule, CommonModule, GenericSharedModule],
    declarations: [ SidebarComponent ],
    exports: [ SidebarComponent ]
})

export class SidebarModule {}
